const news_en = `Since April 29, 2025, in addition to the dpa-Weblines, the dpa-Basisdienst and the 12 dpa-Landesdienste have also been delivered as rich multimedia articles.

That means:

- Articles can contain linked images (i.e. the \`associations\` list in the dpa-digitalwires format may contain entries).
- There may be embedded content in the article text (\`article_html\` in the dpa-digitalwires format) e.g. positioned images (\`dnl-image\`) or X-Posts (\`dnl-twitterembed\`).


#### Multimedia dpa-Basisdienst

<codeblockbrowser to='/res/bdt-multimedial.json'></codeblockbrowser>`

export { news_en }


// WEBPACK FOOTER //
// ./src/all_cards/docu/news_en.js